import { observable } from 'mobx';

export type OrderItemPriceDetailResponseArgs = {
  id: number;
  name?: string;
  price: number;
  detail_trace_id?: number;
  order_item_price_id?: number;
  tax_type_id?: number;
  trip_report_id?: number | null;
};

export type OrderItemPriceDetailArgs = {
  id?: number;
  name?: string;
  price: number;
  detailTraceId?: number;
  orderItemPriceId?: number;
  taxTypeId?: number;
  tripReportId?: number | null;
};

export const convertOrderItemPriceDetailResponseToArgs = (response: OrderItemPriceDetailResponseArgs) => {
  const args: OrderItemPriceDetailArgs = {
    id: response.id,
    name: response.name,
    price: response.price,
    detailTraceId: response.detail_trace_id,
    orderItemPriceId: response.order_item_price_id,
    taxTypeId: response.tax_type_id,
    tripReportId: response.trip_report_id
  };
  return args;
};

export default class OrderItemPriceDetail {
  @observable id?: number;
  @observable name?: string;
  @observable price: number;
  @observable detailTraceId?: number;
  @observable orderItemPriceId?: number;
  @observable taxTypeId?: number;
  @observable tripReportId?: number | null;

  constructor(args: OrderItemPriceDetailArgs) {
    this.id = args.id;
    this.name = args.name;
    this.price = args.price;
    this.detailTraceId = args.detailTraceId;
    this.orderItemPriceId = args.orderItemPriceId;
    this.taxTypeId = args.taxTypeId;
    this.tripReportId = args.tripReportId;
  }

  get updateParams() {
    return {
      name: this.name,
      price: this.price,
      detail_trace_id: this.detailTraceId,
      order_item_price_id: this.orderItemPriceId,
      tax_type_id: this.taxTypeId,
      trip_report_id: this.tripReportId
    };
  }
}
